<template>
  <base-section
    id="silver"
    style="padding-bottom: 0px"
  >
    <v-container>
      <base-section-heading title="Silver Supporters" />
        <v-container>
            <v-row>
                <v-col
                cols="12"
                md="12"
                sm="12"
                >
            <a
              :href="partners[0].to"
              target="_blank"
            >
              <base-img
                class="align-self-center"
                v-bind="partners[0]"
                color="grey"
                contain
                height="50px"
                width="100%"
              />
            </a>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SilverSponsors',
    data: () => ({
      visibleWidthSilver: false,
      partners: [
        {
          src: require('@/assets/silver-1.jpg'),
          to: 'https://www.synopsys.com',
        },
      ],
      partnersDuplicated: [
        {
          src: require('@/assets/logo-1-light.png'),
          to: 'https://www.ieee.org',
        },
        {
          src: require('@/assets/logo-2-light.png'),
          to: 'https://ieee-ceda.org',
        },
        {
          src: require('@/assets/logo-3-light.png'),
          to: 'https://www.cnrs.fr/en',
        },
        {
          src: require('@/assets/logo-1-light.png'),
          to: 'https://www.ieee.org',
        },
        {
          src: require('@/assets/logo-2-light.png'),
          to: 'https://ieee-ceda.org',
        },
        {
          src: require('@/assets/logo-3-light.png'),
          to: 'https://www.cnrs.fr/en',
        },
      ],
    }),
    mounted () {
      if (document.getElementById('mover_silver')) {
        //  document.getElementById('mover_silver').children[1].style.overflow = 'visible'
        document.getElementById('mover_silver').children[1].style.whiteSpace = 'no-wrap'
        //  document.getElementById('mover').children[1].style.width = '176'
        document.getElementById('mover_silver').children[1].children[0].classList.add('mover')
      }
      window.addEventListener('resize', this.isMobileDevice)
      this.visibleWidthSilver = this.isMobileDevice()
    },
    methods: {
      isMobileDevice () {
        //  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        if (window.innerWidth < (176 * 3)) {
          this.visibleWidthSilver = true
          return true
        } else {
          this.visibleWidthSilver = false
          return false
        }
      },
    },
  }
</script>
